import { defineMessages } from 'react-intl';

export const homeMessages = defineMessages({
    dashboard: {
        id: 'dashboard',
        defaultMessage: 'Dashboard',
    },
    gatewayPasses: {
        id: 'gateway-passes',
        defaultMessage: 'Gateway passes',
    },
    parkingStay: {
        id: 'parking-stay',
        defaultMessage: 'Parking stay',
    },
    identifiers: {
        id: 'identifiers',
        defaultMessage: 'Identifiers',
    },
    eventLog: {
        id: 'event-log',
        defaultMessage: 'Event log',
    },
    totalEventsToday: {
        id: 'total-events-today',
        defaultMessage: 'Total events today',
    },
    lastTenEvents: {
        id: 'last-ten-events',
        defaultMessage: 'Last 10 events',
    },
    time: {
        id: 'time',
        defaultMessage: 'Time',
    },
    identifier: {
        id: 'identifier',
        defaultMessage: 'Identifier',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    passedOn: {
        id: 'passed-on',
        defaultMessage: 'Passed on',
    },
    visitor: {
        id: 'visitor',
        defaultMessage: 'Visitor',
    },
    totalEntriesToday: {
        id: 'total-entries-today',
        defaultMessage: 'Total entries today',
    },
    lastTenEntries: {
        id: 'last-ten-entries',
        defaultMessage: 'Last 10 entries',
    },
    totalExitsToday: {
        id: 'total-exits-today',
        defaultMessage: 'Total exits today',
    },
    lastTenExits: {
        id: 'last-ten-exits',
        defaultMessage: 'Last 10 exits',
    },
    totalOccupancy: {
        id: 'total-occupancy',
        defaultMessage: 'Total occupancy',
    },
    totalOccupancyDescription: {
        id: 'total-occupancy-description',
        defaultMessage: 'Real-time occupancy by visitor type',
    },
    freeSpacesByZones: {
        id: 'free-spaces-by-zones',
        defaultMessage: 'Free spaces by zones',
    },
    freeSpacesByZonesDescription: {
        id: 'free-spaces-by-zones-description',
        defaultMessage: 'Real-time occupancy by zones',
    },
    totalSpaces: {
        id: 'total-spaces',
        defaultMessage: 'Total spaces',
    },
    clientSpaces: {
        id: 'client-spaces',
        defaultMessage: 'Client spaces',
    },
    memberSpaces: {
        id: 'member-spaces',
        defaultMessage: 'Member spaces',
    },
    total: {
        id: 'total',
        defaultMessage: 'Total',
    },
    clients: {
        id: 'clients',
        defaultMessage: 'Clients',
    },
    members: {
        id: 'members',
        defaultMessage: 'Members',
    },
    totalVisits: {
        id: 'total-visits',
        defaultMessage: 'Total visits',
    },
    totalVisitsDescription: {
        id: 'total-visits-description',
        defaultMessage: 'All visits today',
    },
    visits: {
        id: 'visits',
        defaultMessage: 'Visits',
    },
    visitors: {
        id: 'visitors',
        defaultMessage: 'Visitors',
    },
    membershipVisits: {
        id: 'membership-visits',
        defaultMessage: 'Membership visits',
    },
    membershipVisitsDescription: {
        id: 'membership-visits-description',
        defaultMessage: 'Membership visits today',
    },
    comparedToLastDay: {
        id: 'compared-to-last-day',
        defaultMessage: 'Compared to last day',
    },
});
